const DEFAULT_TITLE = "AutoPark – Prémium használtautó marketplace";
const DEFAULT_DESC =
  "AutoPark: prémium használtautók Magyarországon. 360° megtekintés, részletes felszereltség, kedvencek és azonnali üzenetküldés az eladónak.";

function upsertMeta(attr, key, content) {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function upsertLink(rel, href) {
  if (!href) return;
  let el = document.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function upsertJsonLd(id, data) {
  const prev = document.getElementById(id);
  if (prev) prev.remove();
  if (!data) return;
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.textContent = JSON.stringify(data);
  document.head.appendChild(script);
}

export function setPageMeta({ title, description, image, url, type = "website" } = {}) {
  const pageTitle = title ? `${title} | AutoPark` : DEFAULT_TITLE;
  const pageDesc = description || DEFAULT_DESC;
  document.title = pageTitle;
  upsertMeta("name", "description", pageDesc);
  upsertMeta("property", "og:title", pageTitle);
  upsertMeta("property", "og:description", pageDesc);
  upsertMeta("property", "og:type", type);
  if (url) upsertMeta("property", "og:url", url);
  if (image) {
    upsertMeta("property", "og:image", image);
    upsertMeta("name", "twitter:card", "summary_large_image");
    upsertMeta("name", "twitter:image", image);
  }
  upsertMeta("name", "twitter:title", pageTitle);
  upsertMeta("name", "twitter:description", pageDesc);
}

export function setCarJsonLd(car, pageUrl) {
  if (!car) {
    upsertJsonLd("autopark-jsonld-car", null);
    return;
  }
  upsertJsonLd("autopark-jsonld-car", {
    "@context": "https://schema.org",
    "@type": "Car",
    name: `${car.make} ${car.model} ${car.year}`,
    brand: { "@type": "Brand", name: car.make },
    model: car.model,
    vehicleModelDate: String(car.year),
    fuelType: car.fuel,
    mileageFromOdometer: {
      "@type": "QuantitativeValue",
      value: car.mileage,
      unitCode: "KMT",
    },
    color: car.color || undefined,
    description: car.description || undefined,
    image: car.image || undefined,
    offers: {
      "@type": "Offer",
      price: car.price,
      priceCurrency: "HUF",
      availability: "https://schema.org/InStock",
      url: pageUrl,
    },
  });
}

export function resetPageMeta() {
  setPageMeta({});
  upsertJsonLd("autopark-jsonld-car", null);
}

export function siteOrigin() {
  return window.location.origin;
}

export function carPageUrl(carOrSlug) {
  if (carOrSlug && typeof carOrSlug === "object") {
    const ref = carOrSlug.slug || carOrSlug.id;
    return ref ? `${siteOrigin()}/auto/${ref}` : siteOrigin();
  }
  return carOrSlug ? `${siteOrigin()}/auto/${carOrSlug}` : siteOrigin();
}

export function setDefaultSiteMeta() {
  setPageMeta({ url: siteOrigin() });
  upsertLink("canonical", siteOrigin());
}
